module.exports = __webpack_public_path__ + "static/media/vehicleIcon.498249bf.svg";